import { render, staticRenderFns } from "./ModalDetailProduct.vue?vue&type=template&id=5e866d72&"
import script from "./ModalDetailProduct.vue?vue&type=script&lang=js&"
export * from "./ModalDetailProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetailProduct.vue?vue&type=style&index=0&id=5e866d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports